<template>
  <div class="vmp-notice-list">
    <main class="vmp-notice-list-container">
      <overlay-scrollbars
        ref="noticeScroll"
        :options="overlayScrollBarsOptions"
        style="height: 100%"
      >
        <ul>
          <li
            class="vmp-notice-list-container__item"
            v-for="(item, index) of noticeList"
            :key="index"
          >
            <i class="vh-saas-iconfont vh-saas-line-gonggao" />
            <p>
              <span class="v-type">{{ $t('host.k_556001') }}</span>
              <span v-html="urlToLink(item.content.content)"></span>
            </p>
            <p class="vmp-notice-item__time">
              {{ item.created_at }}
              <vh-dropdown placement="bottom-start" trigger="click" @command="handleCommand">
                <span class="vh-dropdown-link">
                  <i class="vh-icon-more"></i>
                </span>
                <vh-dropdown-menu slot="dropdown" class="notice-operate">
                  <vh-dropdown-item :command="{ item, type: 'del' }">
                    {{ $t('host.k_556002') }}
                  </vh-dropdown-item>
                </vh-dropdown-menu>
              </vh-dropdown>
            </p>
          </li>
        </ul>
      </overlay-scrollbars>
    </main>

    <footer class="vmp-notice-list-textarea">
      <div class="operate-container__tool-bar" v-if="!auth_gd">
        <div class="notice_set">
          <i class="vh-saas-iconfont vh-saas-a-line-zhikanzhubanfang" @click="handleConfig"></i>
          <vh-dialog
            :title="$t('host.k_556003')"
            :visible.sync="showConfig"
            :close-on-click-modal="false"
            append-to-body
            custom-class="notice_setting"
            width="540px"
          >
            <div class="dialog-body">
              <vh-form
                class="setting_notice"
                :label-position="$i18n.locale === 'en' ? 'top' : 'right'"
              >
                <vh-form-item :label="$t('host.k_556004')">
                  <vh-radio-group v-model="noticeConfig.display_type">
                    <vh-radio :label="0">{{ $t('host.k_556005') }}</vh-radio>
                    <vh-radio :label="1">{{ $t('host.k_556006') }}</vh-radio>
                  </vh-radio-group>
                </vh-form-item>
                <div class="set_tip">
                  <label>{{ $t('host.k_556007') }}</label>
                  <p class="set_tip_content">
                    {{ $t('host.k_556008') }}
                    <vh-tooltip
                      placement="right"
                      popper-class="notice_preview"
                      effect="light"
                      :visible-arrow="false"
                    >
                      <span class="link">{{ $t('host.k_556009') }}</span>
                      <img style="width: 240px" slot="content" src="./img/notice_preview.png" />
                    </vh-tooltip>

                    <br />
                    {{ $t('host.k_556010') }}
                  </p>
                </div>
                <vh-form-item :label="$t('host.k_556011')" style="margin-bottom: 0">
                  <vh-radio-group v-model="noticeConfig.static">
                    <vh-radio :label="0">{{ $t('host.k_556012') }}</vh-radio>
                    <vh-radio :label="60">{{ $t('host.k_556013') }}</vh-radio>
                    <vh-radio :label="120">{{ $t('host.k_556014') }}</vh-radio>
                    <vh-radio :label="300">{{ $t('host.k_556015') }}</vh-radio>
                    <br />
                    <vh-radio :label="600">{{ $t('host.k_556016') }}</vh-radio>
                    <vh-radio :label="-1">
                      <vh-input
                        class="custom_input"
                        v-model="noticeConfig.custom"
                        type="number"
                        placeholder="1-9999"
                        :maxlength="4"
                        size="medium"
                        @blur="validateCustom"
                      >
                        <i class="input_suffix" slot="suffix">{{ $t('host.k_556017') }}</i>
                      </vh-input>
                    </vh-radio>
                  </vh-radio-group>
                </vh-form-item>
                <vh-form-item :label="$t('host.k_556018')">
                  <vh-radio-group v-model="noticeConfig.record_display">
                    <vh-radio :label="0">{{ $t('host.k_556019') }}</vh-radio>
                    <vh-radio :label="1">{{ $t('host.k_556020') }}</vh-radio>
                  </vh-radio-group>
                </vh-form-item>
              </vh-form>
            </div>
            <div slot="footer">
              <vh-button plain size="medium" round @click="showConfig = false">
                {{ $t('host.k_556021') }}
              </vh-button>
              <vh-button type="primary" size="medium" round @click="setNotice">
                {{ $t('host.k_556022') }}
              </vh-button>
            </div>
          </vh-dialog>
          <!-- <section class="setting_notice" v-show="showConfig">
          <label class="label_txt">展示时长</label>
          <div>
            <vh-radio-group v-model="noticeConfig.static" @change="setNotice">
              <p class="radio_item"><vh-radio :label="0">{{ $t('host.k_556012') }}</vh-radio></p>
              <p class="radio_item"><vh-radio :label="60">{{ $t('host.k_556013') }}</vh-radio></p>
              <p class="radio_item"><vh-radio :label="120">{{ $t('host.k_556014') }}</vh-radio></p>
              <p class="radio_item"><vh-radio :label="300">{{ $t('host.k_556015') }}</vh-radio></p>
              <p class="radio_item"><vh-radio :label="600">{{ $t('host.k_556016') }}</vh-radio></p>
              <p class="radio_item">
                <vh-radio :label="-1">
                  <vh-input
                    class="custom_input"
                    v-model="noticeConfig.custom"
                    type="number"
                    placeholder="1-9999"
                    :maxlength="4"
                    size="mini"
                    @blur="validateCustom"
                  >
                    <i class="input_suffix" slot="suffix">{{ $t('host.k_556017') }}</i>
                  </vh-input>
                </vh-radio>
              </p>
            </vh-radio-group>
          </div>
        </section> -->
        </div>
      </div>
      <div class="toSay">
        <div class="clearfix text-box">
          <textarea
            class="mywords fl"
            :placeholder="$t('host.k_556023')"
            v-on:keyup.enter="sendNotice"
            v-model.trim="inputVal"
            name="xword"
            maxlength="300"
          ></textarea>
          <div class="send-btn-box" @click="sendNotice">
            <div class="send-btn"><i class="vh-iconfont vh-line-send"></i></div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
  import { urlToLink } from '@/app-shared/utils/common.js';
  import { useMsgServer, useNoticeServer, useRoomBaseServer, CNTz2CurTz } from 'middle-domain';
  import { debounce } from 'lodash';
  export default {
    name: 'VmpNoticeList',
    data() {
      const domainState = this.noticeServer.state;

      return {
        domainState,
        noticeList: [],
        pageInfo: {
          pos: 0,
          limit: 100,
          pageNum: 1
        },
        inputVal: '',
        overlayScrollBarsOptions: {
          resize: 'none',
          paddingAbsolute: true,
          className: 'os-theme-light os-theme-vhall',
          scrollbars: {
            autoHide: 'leave',
            autoHideDelay: 200
          }
        },
        noticeConfig: {
          display_type: 0,
          static: 0,
          custom: 90,
          record_display: 0 //回放显示
        },
        showConfig: false,
        oldCustom: 90 //上一个满足要求的自定义时间
      };
    },
    computed: {
      watchInitData() {
        return this.$domainStore.state.roomBaseServer.watchInitData;
      },
      webinarType() {
        // //直播状态 1-直播中，2-预约，3-结束，4-点播，5-回放
        return Number(this.roomBaseServer.state.watchInitData.webinar.type);
      },
      // guodu  权限
      auth_gd() {
        return this.$domainStore.state.roomBaseServer.embedSource == 'gd';
      }
    },
    beforeCreate() {
      this.urlToLink = urlToLink('', {
        aClassNameStr: 'url-content-link',
        needXss: true
      });
      this.msgServer = useMsgServer();
      this.noticeServer = useNoticeServer();
      this.roomBaseServer = useRoomBaseServer();
    },
    created() {
      this.roomBaseState = this.roomBaseServer.state;
      // 保持和线上一直，不调用接口， 刷新时，就没有公告了
      this.getNoticeList(false);
    },
    mounted() {
      this.initNotice();
    },
    methods: {
      showDelNotice(item) {
        // 展示删除公告弹窗
        this.$vhConfirm(this.$t('host.k_556024'), this.$t('host.k_556025'), {
          confirmButtonText: this.$t('host.k_556022'),
          cancelButtonText: this.$t('host.k_556021'),
          roundButton: true,
          closeOnClickModal: false
        })
          .then(() => {
            this.delNotice(item);
          })
          .catch();
      },
      delNotice(item) {
        // 删除某个公告
        const { watchInitData } = this.roomBaseState;
        const params = {
          room_id: watchInitData.interact.room_id,
          id: item.id
        };
        this.noticeServer
          .delNotice(params)
          .then(() => {
            console.log('删除成功');
          })
          .catch(err => {
            console.log(err);
          });
      },
      handleCommand(command) {
        const { type, item } = command;
        if (type === 'del') {
          this.showDelNotice(item);
        }
      },
      /**
       * 初始化scroll区域
       */
      initScroll() {
        this.osInstance = this.$refs.noticeScroll.osInstance();
        this.osInstance.options(this.overlayScrollBarsOptions);
      },
      /**
       * 初始化notice
       */
      initNotice() {
        this.noticeServer.$on('room_announcement', msg => {
          this.noticeList.unshift({
            created_at: CNTz2CurTz(msg.push_time),
            content: {
              content: msg.room_announcement_text
            },
            id: msg.id
          });
        });
        this.noticeServer.$on('set_notice_config', msg => {
          const { duration, set_type, display_type, record_display } = msg;
          if (set_type == 1) {
            this.noticeConfig.static = Number(duration);
          } else {
            this.noticeConfig.static = -1;
            this.noticeConfig.custom = Number(duration);
          }
          this.noticeConfig.display_type = Number(display_type);
          this.noticeConfig.record_display = Number(record_display);
        });

        this.noticeServer.$on('live_over', () => {
          this.noticeList = [];
          this.noticeConfig.static = 0;
          this.noticeConfig.custom = 90;
          this.noticeConfig.display_type = 0;
          this.noticeConfig.record_display = 0;
        });
        this.noticeServer.$on('del_room_announcement', msg => {
          let list = this.noticeList.filter(item => item.id !== msg.id);
          this.noticeList = list;
        });
        //初始化公告配置
        const { duration, set_type, record_display, display_type } =
          this.noticeServer.getNoticeConfig();
        if (set_type == 1) {
          this.noticeConfig.static = duration;
        } else {
          this.noticeConfig.static = -1;
          this.noticeConfig.custom = duration || 90;
        }
        this.noticeConfig.record_display = record_display || 0;
        this.noticeConfig.display_type = Number(display_type);
      },
      hiddenConfig() {
        this.showConfig = false;
      },
      handleConfig() {
        // if (this.webinarType != 1) {
        //   this.$message.error('未开播状态禁止调用');
        //   return;
        // }
        this.showConfig = !this.showConfig;
      },
      //检验处理自定义展示时长
      validateCustom() {
        if (this.noticeConfig.custom <= 9999 && this.noticeConfig.custom >= 1) {
          this.noticeConfig.custom = this.oldCustom = Math.floor(this.noticeConfig.custom);
        } else {
          this.noticeConfig.custom = this.oldCustom;
        }
      },
      /**
       * 获取历史消息列表
       * @param {Boolean} isLoadMore
       */
      async getNoticeList(isLoadMore = true) {
        const { watchInitData } = this.roomBaseState;
        const params = {
          room_id: watchInitData.interact.room_id,
          is_cache: 1,
          ...this.pageInfo
        };
        try {
          const res = await this.noticeServer.getNoticeList({ params, flag: isLoadMore });
          if (res.code === 200) {
            const list = res.data?.list;
            if (list?.length > 0) {
              this.noticeList = list.map(msg => {
                return {
                  created_at: msg.created_at,
                  content: msg.content,
                  id: msg.id
                };
              });
            }
          } else {
            this.$message.error(res.msg);
          }
        } catch (error) {
          console.warn('获取公告消息错误', error);
        }
      },
      /**
       * 读取更多data
       */
      moreLoadData() {
        if (this.pageInfo.pageNum >= this.domainState.totalPages) {
          return false;
        }
        this.pageInfo.pageNum++;
        this.pageInfo.pos = parseInt((this.pageInfo.pageNum - 1) * this.pageInfo.limit);
        this.getNoticeList(true);
      },
      async setNotice() {
        const res = await this.noticeServer.setNotice({
          duration:
            this.noticeConfig.static < 0 ? this.noticeConfig.custom : this.noticeConfig.static,
          set_type: this.noticeConfig.static < 0 ? 2 : 1,
          display_type: this.noticeConfig.display_type,
          record_display: this.noticeConfig.record_display // 是否回放显示 需后端提供真实状态
        });
        if (res.code != 200) {
          this.$message.error(res.msg);
        } else {
          this.showConfig = false;
        }
      },
      /**
       * 发送一条公告
       */
      sendNotice: debounce(function () {
        if (this.webinarType != 1) {
          //非直播状态
          return this.$message.warning(this.$t('host.k_556026'));
        }
        if (this.inputVal === '' || this.inputVal === undefined) {
          return this.$message.warning(this.$t('host.k_556027'));
        }
        const params = {
          messageType: 1,
          roomId: this.watchInitData.interact.room_id,
          channel_id: this.watchInitData.interact.channel_id,
          content: this.inputVal
        };
        try {
          this.noticeServer.sendNotice(params);
          this.inputVal = '';
        } catch (error) {
          console.warn('发送公告消息错误', error);
        }
      }, 500)
    }
  };
</script>

<style lang="less" scoped>
  .vmp-notice-list {
    .os-theme-dark > .os-scrollbar > .os-scrollbar-track > .os-scrollbar-handle,
    .os-theme-light > .os-scrollbar > .os-scrollbar-track > .os-scrollbar-handle,
    .os-theme-dark > .os-scrollbar > .os-scrollbar-track,
    .os-theme-light > .os-scrollbar > .os-scrollbar-track {
      border-radius: 6px;
    }
    .os-theme-light > .os-scrollbar > .os-scrollbar-track > .os-scrollbar-handle {
      background: #666666;
    }
    .os-theme-light > .os-scrollbar:hover > .os-scrollbar-track > .os-scrollbar-handle {
      background-color: #666666;
    }
    height: 100%;
    position: relative;
    &-container {
      height: calc(100% - 102px);
      width: 100%;
      background: transparent;
      background-size: 100% 100%;

      &__item {
        position: relative;
        background-color: #2d2d2d;
        width: 100%;
        box-sizing: border-box;
        padding: 14px 20px 14px 43px;
        .vh-link {
          text-decoration: underline #0a7ff5 !important;
        }
        &:not(:first-child) {
          margin-top: 1px;
        }

        i.vh-saas-line-gonggao {
          display: inline-block;
          position: absolute;
          top: 16px;
          font-size: 14px;
          color: #fba511;
          left: 15px;
        }

        p {
          width: 100%;
          word-break: break-all;
          font-size: 12px;
          color: #ececec;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          padding-right: 20px;
        }

        .vmp-notice-item__time {
          color: #999;
          margin-top: 4px;
          .vh-dropdown {
            margin-left: 9px;
            color: #bfbfbf;
            i {
              cursor: pointer;
              vertical-align: middle;
            }
            &:hover {
              color: #fff;
            }
          }
        }
      }

      &-data {
        position: absolute;
        top: 108px;
        left: 60px;
        width: 352px;
        max-height: 267px;
        padding-right: 20px;
        overflow: auto;
        color: @font-light-normal;
        ul {
          list-style: none;
          height: 100%;
          li {
            display: flex;
            color: @font-light-normal;
            font-size: 14px;
            line-height: 20px;
          }
        }
        &-time {
          display: inline-block;
          width: 50px;
          text-align: left;
        }
        &-text {
          display: flex;
          position: relative;
          // padding-bottom: 16px;
          width: calc(100% - 50px);
          &-circle {
            display: inline-block;
            width: 11px;
            height: 11px;
            border-radius: 50%;
            background: #fff4f4;
            border: 1px solid #ffc5c3;
            top: 4px;
            left: -6px;
            position: absolute;
            i {
              display: inline-block;
              width: 7px;
              height: 7px;
              border-radius: 50%;
              background: @bg-error-light;
              position: absolute;
              top: 2px;
              left: 2px;
            }
          }
          &-title {
            padding-left: 16px;
            word-break: break-word;
            padding-bottom: 16px;
            border-left: 1px dashed #ffc5c3;
            border-radius: 2px;
          }
        }
      }
      &-close {
        position: absolute;
        top: 60px;
        right: 75px;
        cursor: pointer;
        cursor: pointer;
        i {
          font-size: 12px;
          color: @font-error;
        }
      }
    }

    &-textarea {
      width: 100%;
      box-sizing: border-box;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 1;
      border-top: 1px solid var(--tab-menu-bg-border);
      padding: 10px;
      .operate-container__tool-bar {
        height: 19px;
        margin-bottom: 9px;
        .vh-saas-iconfont {
          font-size: 18px;
          color: #999;
          cursor: pointer;
          &:hover {
            color: #fb3a32;
          }
        }
      }
      .toSay {
        position: relative;
        background-color: transparent;
        height: 100%;
      }
      .text-box {
        display: flex;
        .mywords {
          border: none;
          background-color: var(--chat-background-color-input);
          padding: 10px 12px;
          box-sizing: border-box;
          height: 40px;
          resize: none;
          outline: none;
          line-height: 20px;
          color: #fff;
          overflow: auto;
          border-radius: 20px;
          box-sizing: border-box;
          font-size: 14px;
          flex: 1;
          width: 0;
        }
        .send-btn-box {
          width: 40px;
          height: 40px;
          border-radius: 20px;
          background-color: var(--chat-background-color-input);
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          margin-left: 8px;
          .send-btn {
            i {
              color: var(--chat-font-color-msg-nickname);
            }
          }
        }
      }
    }
  }
  .notice-operate {
    width: 120px;
    .vh-dropdown-menu__item {
      line-height: 31px;
    }
  }
  .vh-button--medium + .vh-button--medium,
  .vh-button--small + .vh-button--small {
    margin-left: 12px;
  }
</style>

<style lang="less">
  .notice_setting {
    position: relative;
    z-index: 9000;
    .setting_notice {
      .custom_input {
        width: 90px;
        .input_suffix {
          line-height: 36px;
          margin-right: 3px;
        }
      }
      .vh-radio {
        vertical-align: middle;
      }
      .vh-radio-group {
        line-height: 42px;
      }
    }
    .set_tip {
      display: flex;
      color: #8c8c8c;
      font-size: 14px;
      line-height: 22px;
      margin-top: -22px;
      margin-bottom: 14px;
      label {
        width: 42px;
      }
      .set_tip_content {
        flex: 1;
        width: 0;
        white-space: normal;
        word-break: break-word;
        overflow-wrap: break-word;

        .link {
          color: #0a7ff5;
        }
      }
    }
    .label_txt {
      width: 48px;
      font-size: 12px;
      margin-right: 12px;
    }
  }
  .notice_preview {
    background: transparent !important;
    box-shadow: none !important;
  }
</style>
